var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 16H154L208 70V224C208 232.837 200.837 240 192 240H64C55.1634 240 48 232.837 48 224V32C48 23.1634 55.1634 16 64 16Z",
    fill: "#E6E8ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 16V58C154 64.6274 159.373 70 166 70H208L154 16Z",
    fill: "#BFC5D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 82C34 73.1634 41.1634 66 50 66H162C170.837 66 178 73.1634 178 82V150C178 158.837 170.837 166 162 166H50C41.1634 166 34 158.837 34 150V82Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93H64.4038L71.0962 125.352L79.1346 93H90.8654L98.9038 125.352L105.596 93H119L106.25 139H92.8462L85 108.5L77.1538 139H63.75L51 93Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132 99H176",
    stroke: "#AAB1BF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132 122H176",
    stroke: "#AAB1BF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132 145H176",
    stroke: "#AAB1BF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74 198H182",
    stroke: "#AAB1BF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74 218H150",
    stroke: "#AAB1BF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word_icon.336840d4c3ef0f7855e49bd28e6cf59e.svg";
export { ForwardRef as ReactComponent };